export enum TripSanitarityMode {
  Off = 0,
  CalculateByTripParts = 1,
  CalculateByDays = 2,
}
